import { render, staticRenderFns } from "./ProductExercises.vue?vue&type=template&id=57ff829c&scoped=true"
import script from "./ProductExercises.vue?vue&type=script&lang=js"
export * from "./ProductExercises.vue?vue&type=script&lang=js"
import style0 from "./ProductExercises.vue?vue&type=style&index=0&id=57ff829c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff829c",
  null
  
)

export default component.exports